/**
 *
 *
 * @author edmsamuel
 */
import React from 'react'
import { Table, DatePicker, Divider, Input, Tag, Tooltip, Badge, Button } from 'antd'
import moment from 'moment'
import numeral from 'numeral'
import View from '../../../components/View'
import Cell from '../../../components/Cell'
import Crud from '../../../components/Crud'
import Api from '../../../Api'
import Exception from '../../../Exception'
import SolicitudPago from '../../Sub/Components/SolicitudPagoForm'
import { ComValidarSuministroEquipo } from './validar-suministro'
import { ComDetallesEquipoSuministrado } from './detalles-economico'
import { ComIngresarPeriodoEquipo } from './ingresar-periodo'
import { ComPeriodosSuministroEquipo, PeriodoRentaListItem } from './periodos-equipo'
import DetalleSuministroEquipo from './detalle-equipo'
import { fnComPdasServicioQuery } from './fnComPdasServicioQuery'
import { AyudaComServicioMaqPeriodoSubSolicitudPago } from './ayuda'

/**
 *
 * @param {*} data
 * @returns
 */
function remapData(data) {
  return data.map(row => {
    const esPrimerPeriodo = row.primerPeriodo === row.id
    const os = row.orden

    return {
      ...row,
      ordenItem: esPrimerPeriodo ? row.ordenItem : null,
      equipo: esPrimerPeriodo ? row.equipo : null,
      folios: esPrimerPeriodo ? os.folio : null,
    }
  })
}

/**
 *
 */
export class PageComStatusRentas extends React.Component {
  /**
   * Constructor
   *
   * @param {Object} props
   */
  constructor(props) {
    super(props)

    this.columns = Cell.buildList([
      //
      { title: 'CONCEPTO', dataIndex: 'sDescripcion', width: '40%', render: (val, row) => (
        <div style={{ marginBottom: 5, marginTop: 5 }}>
          {/* os.folio */}
          <Tooltip title='Folio de OS en que se solicita el suministro'>
            <Tag color='purple'>{row.orden.sConsecutivo}</Tag>
          </Tooltip>

          {/* um */}
          <Tooltip title='Tiempo de contratación'>
            <Tag color="geekblue">{`${numeral(row.dCantidad).format('0,0')} ${row.medida.sNombre}`}</Tag>
          </Tooltip>

          <span>{val}</span>
        </div>
      )},

      //
      { title: 'NO. ECONOMICO', dataIndex: 'equipoSuministrado.economico', width: '15%', render: (val, row) => (
        <div>
          {row.equipoSuministrado ? (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {/* no economico */}
              <Tooltip
                title={<span>
                    <span style={{ marginBottom: 5 }}>No. ecónomico de la unidad o equipo que entregó</span>
                    <br/>
                    {row.equipoSuministrado.status === 'VALIDADA' ? null : (
                      <Tag color='orange'>CONFIRMACIÓN PENDIENTE</Tag>
                    )}
                  </span>
                }
                children={
                  <Tag color={row.equipoSuministrado.status === 'VALIDADA' ? 'green' : 'orange'}>{val || 'SIN DEFINIR'}</Tag>
                }
              />

              {/* eq details */}
              <ComDetallesEquipoSuministrado
                text={val}
                onClick={() => {
                  this.eq.showModal()
                  this.eq.load(row.equipoSuministrado.iId)
                }}
              />

              <Divider type='vertical' />

              {/* payment details */}
              <Badge count={row.equipoSuministrado.periodosRenta.length} style={{ backgroundColor: '#108ee9' }}>
                <ComIngresarPeriodoEquipo
                  onClick={() => this.setState({ pdaSeleccionada: JSON.parse(JSON.stringify(row)) })}
                />
              </Badge>
            </div>
          ) : (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Tooltip title='No se ha entregado la unidad correspondiente a esta partida'>
                <Tag color='volcano'>NO ENTREGADO</Tag>
              </Tooltip>

              <ComValidarSuministroEquipo
                pda={row}
                onValidado={() => this.reload()}
              />
            </div>
          )}
        </div>
      )},

      { title: 'PERIODOS / FACTURAS', width: '35%', dataIndex: 'equipoSuministrado.descripcion', render: (val, row) => (
        <div>
          {!row.equipoSuministrado ? null : row.equipoSuministrado.periodosRenta.slice(0, 3).map(p =>
            <PeriodoRentaListItem
              key={p.iId.toString()}
              periodo={p}
              onEditarSolicitudPago={sol => {
                this.solicitudPago.load(sol.iId)
                this.solicitudPago.showModal()
              }}
            />
          )}
        </div>
      )}
    ])

    this.state = {
      ayudaVisible: false,
      loading: false,
      inicio: -1,
      termino: -1,
      busqueda: '',
      data: [],
    }
  }

  /**
   *
   * @param {*} id
   */
  crearPagoPeriodo = (id) => {
    this.setState({ loading: true, })
    Api.post('/kernel/jobs/do', { identificador: 'maq@crearOrdenPagoMaqBitacoraPeriodo', params: [id] })
      .then(() => {
        this.setState({ loading: false })
        return this.reload()
      })
      .catch(err => {
        this.setState({ loading: false })
        Exception.load(err).show()
      })
  }

  /**
   * Invocado cuando el componente es montado
   */
  async componentDidMount() {
    await this.load(
      moment().startOf('month').add(-6, 'months').format('YYYY-MM-DD'),
      moment().endOf('month').format('YYYY-MM-DD'),
    )
  }

  /**
   * Cargar
   */
  load = async (desde = -1, hasta = -1, search = '') => {
    try {
      this.setState({
        data: [],
        loading: true,
        query: { inicio: desde, termino: hasta }
      })

      const q = fnComPdasServicioQuery({ desde, hasta, search })
      const response = await Api.query(q)

      this.setState({
        data: response.data,
        loading: false,
        inicio: desde,
        termino: hasta,
        busqueda: search,
      })
    } catch (error) {
      alert('error')
      this.setState({
        data: [],
        loading: false,
      })
      Exception.load(error).show()
    }
  }

  /**
   * Reload
   *
   */
  reload = async () => {
    await this.load(
      this.state.query.inicio,
      this.state.query.termino,
      this.state.busqueda,
    )
  }

  /**
   * Render
   *
   */
  render() {
    const { pdaSeleccionada } = this.state
    const crud = (
      <Crud
        buttons={['reload']}
        onReload={this.reload}
        onAdd={() => this.solicitudPago.showModal()}
      />
    )

    const tableTitle = (
      <div>
        <DatePicker.RangePicker
          defaultValue={[moment().add(-6, 'months').startOf('month'), moment().endOf('month')]}
          onChange={
            (_, fechas) =>
              this.load(
                fechas[0].length > 0 ? fechas[0] : -1,
                fechas[1].length > 0 ? fechas[1] : -1,
                this.state.busqueda,
              )
          } />
        <Divider type='vertical' />
        <Input.Search
          placeholder='Buscar'
          style={{ width: 185 }}
          onSearch={value =>
            this.load(this.state.inicio, this.state.termino, value.trim())
          }
          allowClear
        />
        <Divider type='vertical' />
        {crud}
        <Divider type='vertical' />
        <Tooltip key='__help' title='Ayuda'>
          <Button icon='question-circle' onClick={() => this.setState({ ayudaVisible: true })} />
        </Tooltip>

        <AyudaComServicioMaqPeriodoSubSolicitudPago
          visible={this.state.ayudaVisible}
          onClose={() => this.setState({ ayudaVisible: false })}
        />
      </div>
    )

    return (
      <View>
        <div style={{ padding: 25, flex: 1, display: 'flex', flexDirection: 'column', overflowY: 'auto' }}>
          <h1 style={{ margin: 0 }}>Renta de máquinaria y equipos</h1>
          <label>SEGUIMIENTO DE PAGO DE EQUIPOS O UNIDADES SUMINISTRADAS</label>
          <br />

          <Table
            rowKey='iId'
            size='small'
            rowClassName='row-pure'
            dataSource={remapData(this.state.data)}
            columns={this.columns}
            loading={this.state.loading}
            pagination={{ pageSize: 100 }}
            title={() => tableTitle}
          />
        </div>

        <ComPeriodosSuministroEquipo
          visible={!!pdaSeleccionada}
          onClose={() => this.setState({ pdaSeleccionada: undefined })}
          info={pdaSeleccionada ? pdaSeleccionada.equipoSuministrado : undefined}
          onEditarSolicitudPago={sol => {
            this.solicitudPago.load(sol.iId)
            this.solicitudPago.showModal()
            this.setState({ pdaSeleccionada: undefined })
          }}
        />

        <DetalleSuministroEquipo
          ref={eq => this.eq = eq}
          onCancel={() => {
            this.reload()
          }}
          onSave={() => {
            this.reload()
          }}
        />

        <SolicitudPago
          ref={ref => this.solicitudPago = ref}
          onCancel={() => this.reload()}
          onSolicitada={() => this.reload()}
          onSave={() => this.reload()}
        />
      </View>
    )
  }
}

export default PageComStatusRentas
